import styled from "styled-components";

type BadgeContainerProps = {
  vehicleFound: boolean | undefined;
  finished: boolean;
}

export const BadgeContainer = styled.div<BadgeContainerProps>`
  display: flex;
  align-items: center;
  width: 100%;
  gap: 0.4rem;
  top: 2px;
  left: 4px;
  margin-top: 12px;

  .badge {
    color: var(--white);
    border-radius: 4px;
    font-weight: bold;
    padding: 8px 4px;
    font-size: 12px;
    flex-grow: 1;
    text-align: center;
  }

  .finished-info {
    background-color: ${({ finished }) => finished ? 'var(--dark-green)' : 'var(--black-300)'};
  }
  
  .found-info {
    background-color: ${({ vehicleFound }) => vehicleFound ? 'var(--dark-green)' : 'var(--black-300)'};
  }
`

export const CardContainer = styled.div`
  display: flex;
  flex-direction: column;
  position: relative;
  width: 100%;
  height: auto;
  padding: 1.5rem;
  background: var(--black-200);
  border-radius: 4px;
  box-sizing: border-box;

  .footer {
    display: flex;
    flex-direction: row;
    width: 100%;
    gap: 1rem;
  }

  .tooltip {
    color: var(--white);
    font-family: DM Sans;
    font-size: 0.86rem !important;
    width: auto;
    opacity: 1 !important;
    text-align: center;

    span {
      text-decoration: underline;
    }
  }

  @media (min-width: 1366px) {
    padding: 1.1rem;
  }
`;

export const CardHeader = styled.header`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: space-between;
  padding: 1rem;
  background-color: var(--black-400);
  border-radius: 0.3rem;
  margin-bottom: 1.2rem;

  .favorite-icon {
    position: absolute;
    top: -2.2rem;
    left: -1rem;
  }

  @media (min-width: 1280px) {
    padding: 1rem;

    img {
      width: 4.3rem;
      height: 4.3rem;
      padding: 1rem;
    }
  }

  @media (min-width: 1366px) {
    padding: 1rem;

    img {
      width: 3.2rem;
      height: 3.2rem;
      padding: 0.7rem;
    }
  }

  @media (min-width: 1440px) {
    padding: 1rem;

    img {
      width: 4rem;
      height: 4rem;
      padding: 1rem;
    }
  }
`;

export const CardHeaderInfo = styled.div`
  display: flex;
  flex-direction: row;
  width: 100%;
  align-items: center;

  input {
    visibility: hidden;
  }

  img {
    width: 4rem;
    height: 4rem;
    padding: 1rem;
    background: var(--black-100);
    border-radius: 4px;
  }

  @media (min-width: 1280px) {
    flex: 1;
  }
`;

export const Description = styled.div`
  margin-left: 1rem;
  display: flex;
  flex-direction: column;
  gap: 0.4rem;

  h2 {
    font-size: 19px;
    font-family: DM Sans;
  }

  p {
    font-size: 14px;
    color: var(--grey-100);
    margin-top: 0.1rem;

    width: auto;
  }

  @media (min-width: 1280px) {
    h2 {
      font-size: 1.25rem;
    }

    p {
      font-size: 1rem;
    }
  }

  @media (min-width: 1366px) {
    h2 {
      font-size: 1.05rem;
    }

    p {
      font-size: 0.85rem;
    }
  }

  @media (min-width: 1440px) {
    h2 {
      font-size: 1.188rem;
    }

    p {
      font-size: 1rem;
    }
  }

  @media (min-width: 1880px) {
    h2 {
      font-size: 1.16rem;
    }

    p {
      font-size: 1rem;
    }
  }
`;

export const CardRow = styled.div`
  display: inline-flex;
  flex-direction: row;
  flex: 1;
  width: 100%;
`;

export const CardItem = styled.div`
  margin-bottom: 1.5rem;
  width: 100%;
  height: 76px;

  .title {
    font-size: 0.875rem;
    color: var(--grey-100);
    margin-bottom: 0.3rem;
  }

  .subtitle {
    font-family: Inter;
    font-size: 16px;
    line-height: 24px;
    color: var(--white);

    overflow: hidden;
    overflow-wrap: break-word;
    text-overflow: ellipsis;
    -webkit-line-clamp: 2;
    display: -webkit-box;
    -webkit-box-orient: vertical;
  }

  .boSubtitle {
    -webkit-line-clamp: 1;
  }

  @media (min-width: 1280px) {
    .title {
      font-size: 0.95rem;
    }

    .subtitle {
      font-size: 1rem;
    }
  }

  @media (min-width: 1366px) {
    .title {
      font-size: 0.84rem;
    }

    .subtitle {
      font-size: 0.95rem;
      color: var(--white);
    }
  }

  @media (min-width: 1440px) {
    .title {
      font-size: 0.875rem;
    }

    .subtitle {
      font-size: 16px;
    }
  }
`;

export const CardBody = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  flex: 1;
  box-sizing: border-box;
`;

export const CardColumn = styled.div`
  width: 50%;
  padding-right: 0.5rem;
`;
